import React from 'react'

export const ButtonRow = ({ 
    className, 
    imgClassName,
    onClick, 
    img, 
    width, 
    height,
    title
    }) => {
    return (
        <button className={className} onClick={onClick} title={"Play"}>
            <img className={imgClassName} src={img} alt={title} width={width} height={height}/>
        </button>
    )
}